<template>
	<helio-message
		:active="'hasErrors' in errors"
		class="error-message"
		icon-token="exclamation-triangle"
		icon-weight="bold"
		state="alert"
		:title="$t('upload.uploader.errors.title')"
		@close="$emit('errorsClosed')"
	>
		<template v-slot:content>
			<ul class="error-message__list">
				<template
					v-for="errorKey in Object.keys(errors)"
					class="error-message__list"
				>
					<li
						v-if="
							errors[errorKey].hasOwnProperty('fileNames')
								&& errors[errorKey].fileNames.length > 0
						"
						:key="errorKey"
						class="error-message__item"
					>
						{{ errors[errorKey].errorMessage }}:
						<span
							v-for="(file, fileIndex) in errors[errorKey].fileNames"
							:key="`${errorKey}-fileName-${fileIndex}`"
							class="error-message__filename"
						>
							{{ formatFileNames(file, fileIndex, errors[errorKey].fileNames) }}
						</span>
					</li>
				</template>
			</ul>
		</template>
	</helio-message>
</template>

<script>
import Message from '../../message/Message.vue';

export default {
	components: {
		'helio-message': Message,
	},

	props: {
		errors: {
			type: Object,
			default: () => {},
		},
	},

	methods: {
		formatFileNames(fileName, fileIndex, fileNameArray) {
			let separator = fileIndex === fileNameArray.length - 2 ? this.$t('upload.uploader.errors.separator') : ', ';
			separator = fileIndex === fileNameArray.length - 1 ? '.' : separator;
			return `${fileName}${separator}`;
		},
	},
};
</script>
<style lang="scss" src="./error-message.scss" />
